"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmptyValueJSON = exports.emptyValueJSON = void 0;
const createSlateNode_1 = require("./createSlateNode");
exports.emptyValueJSON = [createSlateNode_1.createSlateNode("", "paragraph")];
exports.createEmptyValueJSON = () => [createSlateNode_1.createSlateNode("", "paragraph")];
//# sourceMappingURL=emptyValueJSON.js.map